import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import {
    Validator
} from 'vee-validate'
import Loader from './../shared/loader'

export default {
    name: 'stockGrn',
    components: {
        Paginate,
        Loader,
        BasicSelect

    },
    data: function () {
        return {
           closeGrnShow:false,
           serialNumber: '',
           lastKeyPressTime: null,
            isBarcodeScan: false,
            barcodeScanTimeout: null,
            is_Loading: false,
            isCount : true,
            srnoErr:''
        }
    },
    created: function () { },
    computed: {
       
    },
    // when a page loads,mounted() will be call
    mounted() {
        var permissionEncrypt = window.localStorage.getItem('userdetail');
        var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.createdbyuserid = userdetail.userid;
        this.useremail = userdetail.email;
        console.log('useremail');
        
        console.log(this.useremail);
        
        // this.clientid = userdetail.clientid;
        // this.userwarehouse = userdetail.warehouseid;
        this.pageno = 0;
        // this.getClientList();
        // this.getWarehouseList();
        this.client = window.localStorage.getItem('selectedClient')
        this.warehouse = window.localStorage.getItem('selectedWarehouse')
        this.warehouseid= this.warehouse
        this.clientid =this.client
        this.user_type = userdetail.utype;
        switch (this.user_type) {
            case 'system_user':
                this.showSelectClient = true;
                this.showSelectWarehouse = true;
                // this.getClientList();
                // this.getWarehouseList();
                break;

            case 'client_user':
                this.clientid = userdetail.clientid;
                this.client = this.clientid;
                // this.getWarehouseList();
                this.showSelectWarehouse = true;
                break;

            case 'warehouse_user':
                this.loginUserEmail = userdetail.email;
                this.warehouseid = userdetail.warehouseid;
                this.warehouse = this.warehouseid;
                this.showSelectClient = true;
                // this.getClientList();

                var roleids = userdetail.roleid.split(',');
                for (var i = 0; i < roleids.length; i++) {
                    if (roleids[i] == 40) {
                        this.purchasingManager = parseInt(roleids[i]);
                    }
                    if (roleids[i] == 41) {
                        this.isInwardUserForPO = true;
                    }
                }
                break;

            default:
                this.$alertify.error(this.$t('common.unauthorisedError'));
                break
        }
    },
    methods: {
       handleSerialInput(event) {
        // System user → allow typing
        if (this.user_type === 'system_user') {
            return;
        }

        const now = Date.now();

        if (!this.lastInputTime) {
            this.lastInputTime = now;
            this.isScannerInput = true;
        }

        const diff = now - this.lastInputTime;
        this.isScannerInput = diff <= 50;

        this.lastInputTime = now;
        clearTimeout(this.scanTimer);
            // Ignore Enter (13) and Tab (9)
			if (event.keyCode === 13 || event.keyCode === 9) {
				return;
			}
            this.scanTimer = setTimeout(() => {
                //  Valid scanner input
                if (this.isScannerInput && this.serialNumber.length > 5) {
                   return  this.$refs.serialInput.focus();;
                }
                else
                {
                    this.$alert('Scan the barcode, manual entry not allowed');
                }
                //  Manual typing detected
                //  MUST clear DOM + model
                if (event && event.target) {
                event.target.value = '';
                }

                this.serialNumber = '';
                document.getElementById("srno").value="";
                this.lastInputTime = null;
                this.isScannerInput = false;

                this.$nextTick(() => {
                    if (this.$refs.serialInput) {
                        this.$refs.serialInput.focus();
                    }
                    
                });

                

            }, 80);
        },

    
        async saveSerialNumber() {
            try {
               var userToken = window.localStorage.getItem('userToken');
			   var myStr = userToken.replace(/"/g, '');
               if (this.serialNumber == '' || this.serialNumber == null) {
                    this.srnoErr = "Serial No is required";
                    return false
                }
               this.input = ({
                    clientid: this.clientid,
                    warehouseid: this.warehouseid,
                    serialnumber: this.serialNumber,
                    useremail: this.useremail
                })
                 axios({
					method: 'POST',
					'url': apiUrl.api_url + 'airtel/saveStockCount',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
                     this.isLoading = false;
                    if(result.data.errorCode == 0){
                        this.$alertify.success(result.data.msg)
                        this.serialNumber = '';
                        document.getElementById("srno").value="";
                    }else{
                        this.$alertify.error(result.data.msg)
                        this.serialNumber = '';
                        document.getElementById("srno").value="";
                         this.$nextTick(() => {
                            this.serialNumber = '';
                            this.$refs.serialInput.focus();
                        });
                    }
                   
				}, error => {
					console.error(error);
				});
            } catch (err) {
              this.$alert('Something went wrong');
            }
        },
        async handleCloseGRN() {
          try {
              var userToken = window.localStorage.getItem('userToken');
			   var myStr = userToken.replace(/"/g, '');
                // if (this.serialNumber == '' || this.serialNumber == null) {
                //     this.srnoErr = "Serial No is required";
                //     return false
                // }
                this.input = ({
                    clientid: this.clientid,
                    warehouseid: this.warehouseid
                })
                axios({
					method: 'POST',
					'url': apiUrl.api_url + 'airtel/pendingGRNCount',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					const count = result.data.count;
                    this.closeGrnShow = true;
                    if (count === 0) {
                       this.isCount = true;
                    } else {
                      this.isCount = false;
                    }
				}, error => {
					console.error(error);
				});
            } catch (err) {
            this.$alert('Unable to check pending GRN');
            }
        },
        closeGrnModal(){
          this.closeGrnShow = false;
        },
        async closeStockGRN() {
             try {
               var userToken = window.localStorage.getItem('userToken');
			   var myStr = userToken.replace(/"/g, '');
            //    if (this.serialNumber == '' || this.serialNumber == null) {
            //         this.srnoErr = "Serial No is required";
            //         return false
            //     }
               this.input = ({
                    clientid: this.clientid,
                    warehouseid: this.warehouseid,
                    //serialnumber: this.serialNumber,
                    useremail: this.useremail
                })
                 axios({
					method: 'POST',
					'url': apiUrl.api_url + 'airtel/closeStockGRN',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
                     this.isLoading = false;
                    if(result.data.errorCode == 0){
                        this.$alertify.success(result.data.msg)
                        this.closeGrnModal()
                    }else{
                        this.$alertify.error(result.data.msg)
                        this.closeGrnModal()
                        this.serialNumber = '';
                        document.getElementById("srno").value="";
                         this.$nextTick(() => {
                            this.serialNumber = '';
                            this.$refs.serialInput.focus();
                        });
                    }
                   
				}, error => {
					console.error(error);
				});
            } catch (err) {
            this.$alert('Failed to close GRN');
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/views/components/stockGrn/stockgrn.component.js